import { TrackingEvent, type TrackingTrackData } from "common-types";
import { send } from "./sender";
import { getDeviceType } from "../../../../device";
import type { TrackingEventSenderBody } from "../types";
import {
  getArticleId,
  getBeaconId,
  getPageLang,
  getSessionId,
  getTrackingPv,
  getTrackingPvGlobal,
  getTrackingPvUid,
  getUserId,
  getWikiId,
  getWikiName,
} from "../utils/beaconParams";
import { getExpBucket } from "utils";

/**
 *
 * External sources—like UCP can push events directly
 * into `window.fandomTrack.q`, which are then picked up by Odyssey once it's ready.
 *
 * Example usage:
 * @see https://github.com/Wikia/unified-platform/blob/master/extensions/fandom/AdEngine/scripts/noAdsTracking.js
 *
 */
export async function sendTrackingEvent({
  event = TrackingEvent.TRACKING_EVENT,
  payload,
}: TrackingTrackData): Promise<void> {
  const body: TrackingEventSenderBody = {
    ...payload,
    url: document.URL,
    session_id: getSessionId(),
    pv_number: getTrackingPv(),
    pv_number_global: getTrackingPvGlobal(),
    pv_unique_id: getTrackingPvUid(),
    beacon: getBeaconId(),
    c: getWikiId(),
    x: getWikiName(),
    lc: getPageLang(),
    s: getWikiSkinOverride(), // overrides getWikiSkin()
    ua: window.navigator.userAgent,
    u: getUserId(),
    a: getArticleId(),
    n: -1,
    exp_bucket: getExpBucket(),
  };

  send(event, body);
}

export function getWikiSkinOverride(): string {
  const isMobilePage = getDeviceType() === "smartphone";

  return `ucp_${isMobilePage ? "mobile" : "desktop"}`;
}
